import { NavLink } from 'react-router';

import type { NavigationLogoProps as BumblebeeNavigationLogoProps } from '@shieldpay/bumblebee/navigation-logo';
import { NavigationLogo as BumblebeeNavigationLogo } from '@shieldpay/bumblebee/navigation-logo';

import type { RemoveNavLinkProperty } from '../../utilities/remove-navlink-property';

export const NavigationLogo = ({
  ...props
}: RemoveNavLinkProperty<BumblebeeNavigationLogoProps>) => {
  return <BumblebeeNavigationLogo {...props} NavLink={NavLink} />;
};
